import { ModelBase, NeoModel, Rules, Validation } from '@singularsystems/neo-core';

@NeoModel
export default class OrganisationInstrumentType extends ModelBase {

    public organisationInstrumentTypeId: number = 0;

    @Rules.Required()
    public organisationId: number = 0;

    @Rules.Required()
    public staticInstrumentTypeId: number = 0;

    // Client only properties / methods
    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }
}